import React from "react";
import { globalFileServer } from "../../../axiosInstance";
import { NavLink } from "react-router-dom";
import { Store } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="legal-details">
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "med.pdf"}
          rel="noreferrer"
        >
          תקנון האתר |
        </a>
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "privacy.pdf"}
          rel="noreferrer"
        >
          {" "}
          מדיניות הפרטיות{" "}
        </a>
        <a
          target="_blank"
          className="privacy"
          href={globalFileServer + "accessibility.pdf"}
          rel="noreferrer"
        >
          | הצהרת נגישות{" "}
        </a>
        <NavLink
          className="privacy"
          to="/workers-needed"
          target="_self"
          onClick={() => window.scrollTo(0, 0)}
        >
          | דרושים{" "}
        </NavLink>
      </div>
      <div className="copyright">
        <span aria-hidden className="footer-site-icon">
          <Store size={18} strokeWidth={2} />
        </span>
        <span>כל הזכויות שמורות להמזון בע"מ</span>
      </div>
    </footer>
  );
};
export default Footer;
